import { H3 as BricksH3 } from '@opendoor/bricks/core';

export const H3: React.FC<React.ComponentProps<typeof BricksH3>> = (props) => (
  <BricksH3
    fontSize={['s2', null, 's3']}
    fontWeight="bolder"
    lineHeight={['120', null, '140']}
    {...props}
  />
);
